import { AuthorizationScope } from '../AuthorizationScope'

const scope: AuthorizationScope = {
  _id: 'WORKSPACE_EMPLOYEES',
  name: 'Workspace Employees',
  type: 'WORKSPACE',
  description: '',
  modules: [],
  actions: ['READ', 'CREATE', 'UPDATE', 'DESTROY', 'RESTORE'],
}

export default scope
